function Contact() {
  return (
    <>
      <section class="mt-7 mb-6">
        <div class="container">
          <div className="row g-3">
            <div className="col-lg-6 col-12">
              <h2 className="h1 fw-semibold ls-sm text-success lh-1 m-0">
                Get in Touch With Us
              </h2>
              <p className="fs-4 lh-1">
                If you have business inquiries or other questions, please fill
                out the following form to contact us.
              </p>
              <div class="mt-4 fs-4 lh-sm">
                <p>
                  <i class="bi bi-telephone text-primary me-2"></i>+91
                  7677245574
                </p>
                <p>
                  <i class="bi bi-envelope-open text-primary me-2"></i>
                  albedoinfo1@gmail.com
                </p>
                <p class="d-flex">
                  <i class="bi bi-geo-alt text-primary me-2"></i>
                  Albedo Institute
                  <br />
                  3rd Floor, Karni Heights,
                  <br />
                  Club Road, near Gossner College,
                  <br />
                  Ranchi, Jharkhand - 834001.
                </p>
              </div>

              <div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3171.702490869665!2d85.3245168101179!3d23.353512003810962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f4e11bfffffffd%3A0xfb04a80abd36d195!2sAlbedo%20Institute!5e1!3m2!1sen!2sin!4v1770539398607!5m2!1sen!2sin"
                  height="350"
                  className="w-100 rounded-4 mt-4"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <form
                class="row needs-validation gx-2 gy-3 rounded-4 bg-light p-6 pt-5"
                novalidate
              >
                <div class="col-12 col-md-6">
                  <label class="form-label" for="fname">
                    Full Name <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    type="text"
                    name="last name"
                    id="fname"
                    placeholder="Enter Full Name"
                    required
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label" for="lname">
                    Email ID
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    type="text"
                    name="last name"
                    id="lname"
                    placeholder="Enter Email ID"
                    required
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label" for="phone">
                    Phone No.
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    type="text"
                    name="phone"
                    id="phone"
                    placeholder="Phone"
                    required
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="text-dark form-label" for="contactReason">
                    Reason
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                  />
                </div>
                <div class="col-12">
                  <label class="text-dark form-label" for="messages">
                    Message
                  </label>
                  <textarea
                    class="form-control"
                    id="messages"
                    rows="5"
                    placeholder="Messages"
                  ></textarea>
                </div>
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-primary px-7 rounded-pill mt-2"
                  >
                    Submit
                  </button>
                </div>

                <i className="text-danger">
                  Our team will respond within 24–48 working hours.
                </i>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
